import { yupResolver } from "@hookform/resolvers/yup";
import { LoadingButton } from "@mui/lab";
import {
  Box,
  Button,
  FormControl,
  FormLabel,
  Grid,
  Stack,
  TextField,
} from "@mui/material";
import { useEffect } from "react";
import { Controller, useForm } from "react-hook-form";
import { useMutation } from "react-query";
import { useNavigate, useParams } from "react-router-dom";
import * as yup from "yup";
import Breadcrumb from "../../components/Breadcrumb";
import MainLayout from "../../components/MainLayout";
import ProtectedPermissionPage from "../../components/ProtectedPermissionPage";
import useNotification from "../../hooks/useNotification";
import { useAppSelector } from "../../hooks/useSelector";
import areaService from "../../services/area";
import queryDefault from "../../utils/queryDefault";

export default function AreaEdit() {
  const notification = useNotification();
  const { id } = useParams();
  const navigate = useNavigate();
  const { user } = useAppSelector((state) => state.global);
  const schema = yup.object().shape({
    name: yup
      .string()
      .min(2)
      .required("name is a required field and length > 2"),
  });
  const form = useForm({
    defaultValues: {
      id: "",
      name: "",
      admin_name: user.username,
    },
    resolver: yupResolver(schema),
  });

  const updateArea = useMutation("edit-area", areaService.updateArea, {
    onSuccess: () => {
      navigate("/app/properties/area");

      notification.onOpen({
        message: "Area was successfully updated!",
        type: "success",
        position: "top",
      });
    },
    onError: () => {
      notification.onOpen({
        message: "Failed Update Area",
        type: "error",
        position: "top",
      });
    },
    ...queryDefault,
  });

  const onSubmit = (values: any) => {
    updateArea.mutate(values);
  };

  useEffect(() => {
    if (id) {
      areaService.getAreaById(Number(id)).then(({ data }) => {
        form.setValue("id", id);
        form.setValue("name", data.name);
      });
    }
  }, [id, form]);

  return (
    <MainLayout>
      <Breadcrumb
        label={`Edit ${form.getValues("name")}`}
        breadcrumbs={[
          { label: "Areas", href: "/app/properties/area" },
          { label: "Edit", href: `/app/properties/area/${id}` },
        ]}
      />

      <ProtectedPermissionPage
        menuSlug="area"
        requiredPermissions={{ is_update: true, is_read: true }}
      >
        <Box sx={{ mt: 2 }}>
          <Grid container>
            <Grid item lg={4} xs={12}>
              <FormControl fullWidth sx={{ mt: 2 }}>
                <FormLabel required>Name</FormLabel>
                <Controller
                  name="name"
                  control={form.control}
                  render={({ field: { ref, ...field }, fieldState }) => (
                    <TextField
                      {...field}
                      inputRef={ref}
                      error={Boolean(fieldState.error?.message)}
                      helperText={fieldState.error?.message}
                      size="small"
                    />
                  )}
                />
              </FormControl>
            </Grid>
          </Grid>
        </Box>
        <Box sx={{ mt: 3 }}>
          <Stack direction="row" spacing={1}>
            <LoadingButton
              variant="contained"
              onClick={form.handleSubmit(onSubmit)}
              loading={updateArea.isLoading}
            >
              SAVE
            </LoadingButton>

            <Button variant="outlined" onClick={() => navigate(-1)}>
              CANCEL
            </Button>
          </Stack>
        </Box>
      </ProtectedPermissionPage>
    </MainLayout>
  );
}
